module.exports = __webpack_public_path__ + "static/media/quote-ltr.9c519d74.svg";